import { Route, Routes } from "react-router-dom";
import Header from "./Components/Header";
import MiniMe from "./Components/MiniMe";
import Homepage from "./Pages/Homepage";
import Work from "./Pages/Work";
import Resume from "./Pages/Resume";

function App() {
  return (
    <>
      <Header />
      <MiniMe />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/projects" element={<Work />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="*" element={<Homepage />} />
      </Routes>
    </>
  );
}

export default App;
